import { render } from "./404case.vue?vue&type=template&id=30e55e32&scoped=true"
import script from "./404case.vue?vue&type=script&lang=js"
export * from "./404case.vue?vue&type=script&lang=js"

import "./404case.vue?vue&type=style&index=0&id=30e55e32&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30e55e32"

export default script